import { parse, format, isValid } from 'date-fns';

const CANDIDATES = ['H:mm:ss', 'HH:mm:ss', 'H:mm', 'HH:mm'] as const;

/** "HH:mm(:ss)" 等を "H:mm" に整形。合わない形式は元の文字列を返す */
export const formatHmDisplay = (input?: string | null) => {
  if (!input) return '';
  const time = String(input).trim();

  for (const pat of CANDIDATES) {
    const d = parse(time, pat, new Date());
    if (isValid(d)) return format(d, 'H:mm');
  }
  return time;
};
